import { getPropsForAccountPage } from "@up/data";
import { Page404 } from "@up/ui";

export const getStaticProps = getPropsForAccountPage;

export default function Page() {
  return <Page404 />;
}
